import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'redux/config'

interface AriaLogMessage {
  value: string
  expirationTime: number
  id: number
}

interface AriaLogReducer {
  messages: AriaLogMessage[]
}

const initialState: AriaLogReducer = {
  messages: []
}

/**
 * This is used for giving aria log messages unique ids. This works
 * great for what we're doing because we are running in a single
 * thread on the browser
 */
let nextMessageId = 0

export const ariaLogSlice = createSlice({
  name: 'AriaLog',
  initialState,
  reducers: {
    logAriaMessage: (state, { payload }: PayloadAction<string>) => {
      const time = Date.now()
      const messageTimeToLive = 5000
      // Remove messages that expired and do not match the payload. If we remove any messages that match the payload,
      // then the payload could end up at the same index that the removed message was. If this happens the screen
      // reader won't be able to detect that it's a new message.
      const liveMessages = state.messages.filter(message => message.expirationTime > time || message.value === payload)
      state.messages = [
        ...liveMessages,
        {
          value: payload,
          expirationTime: time + messageTimeToLive,
          id: nextMessageId++
        }
      ]
    }
  }
})

export default ariaLogSlice.reducer
export const {
  logAriaMessage
} = ariaLogSlice.actions

export const getAriaLiveLog = (state: RootState) => ({
  messages: state.ariaLog.messages.map(message => ({ message: message.value, id: message.id }))
})
